// Generated by Melange

import * as Buhta_cabinet__Ident from "../grpc/Ident.js";
import * as Buhta_cabinet__IdentFaceScanPanel from "../components/organisms/Ident/IdentFaceScanPanel.js";
import * as Buhta_cabinet__IdentIdScanPanel from "../components/organisms/Ident/IdentIdScanPanel.js";
import * as Buhta_cabinet__IdentInitPanel from "../components/organisms/Ident/IdentInitPanel.js";
import * as Buhta_components__Text from "../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const emptyAction = {
  id: "",
  "type'": /* VERIFIABLE_TYPE_UNSPECIFIED */0,
  state: "",
  provider: /* IDENT_PROVIDER_UNSPECIFIED */0,
  action: "not_set"
};

const emptyData = {
  id: "",
  code: "",
  session_id: "",
  state: "",
  current_action: undefined
};

function IdentFlowPage(Props) {
  let code = Props.code;
  const match = React.useState(function () {
        return emptyData;
      });
  const setIdentData = match[1];
  const identData = match[0];
  const match$1 = React.useState(function () {
        return /* Init */0;
      });
  const setState = match$1[1];
  const onScanFinish = function (scanId, actionId, actionType, accessToken) {
    let tmp;
    if (actionType >= 3) {
      tmp = {
        verifiable: "not_set"
      };
    } else {
      switch (actionType) {
        case /* VERIFIABLE_TYPE_UNSPECIFIED */0 :
            tmp = {
              verifiable: "not_set"
            };
            break;
        case /* VERIFIABLE_TYPE_ID_CARD_SCAN */1 :
            tmp = {
              verifiable: {
                NAME: "Id_card_scan_data",
                VAL: {
                  scan_session_token: scanId
                }
              }
            };
            break;
        case /* VERIFIABLE_TYPE_LIVENESS */2 :
            tmp = {
              verifiable: {
                NAME: "Liveness_data",
                VAL: {
                  client_session_token: scanId
                }
              }
            };
            break;
        
      }
    }
    const form_data = tmp;
    const form = {
      id: actionId,
      "type'": actionType,
      data: form_data
    };
    const __x = Buhta_cabinet__Ident.IdentFlowService.$$process(code, form);
    $$Promise.getOk(__x, (function (data) {
            Curry._1(setIdentData, (function (param) {
                    return data;
                  }));
          }));
  };
  React.useEffect((function () {
          const __x = Buhta_cabinet__Ident.IdentFlowService.lookup(code, undefined);
          $$Promise.getOk(__x, (function (data) {
                  Curry._1(setIdentData, (function (param) {
                          return data;
                        }));
                }));
        }), [code]);
  const sessionId = identData.session_id;
  const value = identData.current_action;
  const currentAction = value !== undefined ? value : emptyAction;
  const match$2 = currentAction.action;
  let accessToken;
  if (typeof match$2 === "string") {
    accessToken = "";
  } else if (match$2.NAME === "Id_scan_info") {
    const token = match$2.VAL.client_access_token;
    accessToken = token !== undefined ? token : "";
  } else {
    const token$1 = match$2.VAL.client_access_token;
    accessToken = token$1 !== undefined ? token$1 : "";
  }
  let tmp;
  if (match$1[0]) {
    const match$3 = currentAction.action;
    if (typeof match$3 === "string") {
      tmp = null;
    } else {
      const variant = match$3.NAME;
      tmp = variant === "Liveness_info" ? JsxRuntime.jsx(Buhta_cabinet__IdentFaceScanPanel.make, {
              sessionId: sessionId,
              accessToken: accessToken,
              actionId: currentAction.id,
              actionType: currentAction["type'"],
              onScanFinish: onScanFinish
            }) : (
          variant === "Id_scan_info" ? JsxRuntime.jsx(Buhta_cabinet__IdentIdScanPanel.make, {
                  sessionId: sessionId,
                  accessToken: accessToken,
                  actionId: currentAction.id,
                  actionType: currentAction["type'"],
                  onScanFinish: onScanFinish
                }) : null
        );
    }
  } else {
    tmp = JsxRuntime.jsx(Buhta_cabinet__IdentInitPanel.make, {
          onStart: (function (param) {
              Curry._1(setState, (function (param) {
                      return /* Scan */1;
                    }));
            })
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("a", {
                      children: JsxRuntime.jsx("img", {
                            className: "h-6 md:h-7",
                            src: StaticAsset.src("/static/icons/logo-black.svg")
                          }),
                      className: "mt-6 md:mt-10",
                      href: "https://buhta.com"
                    }),
                tmp,
                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                      className: "mt-16 text-default-gray",
                      children: "© 2014-2024 Бухта"
                    })
              ],
              className: "bg-gray-pale h-100vh flex flex-col items-center font-hauss pb-6 md:pb-14 px-4 overflow-y-auto"
            });
}

const emptyFormAction = {
  id: "",
  "type'": /* VERIFIABLE_TYPE_UNSPECIFIED */0,
  data: undefined
};

const make = IdentFlowPage;

export {
  emptyFormAction ,
  emptyAction ,
  emptyData ,
  make ,
}
/* Buhta_cabinet__Ident Not a pure module */
